// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ideas-wall-remote-controller .remote-container {
  background: rgba(0, 0, 0, 0.3490196078);
}
ideas-wall-remote-controller .remote-container .content {
  width: 90%;
  height: 80%;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
}
ideas-wall-remote-controller .remote-container .content .button-tab {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #305792;
  margin-right: 10px;
}
ideas-wall-remote-controller .remote-container .content .button-tab.close {
  opacity: 1;
  margin-top: -25px;
  margin-right: -5px;
}
ideas-wall-remote-controller .remote-container .content .button-tab.close mat-icon {
  width: 20px;
  height: 20px;
  font-size: 20px;
}
ideas-wall-remote-controller .remote-container .content .tab-header {
  padding: 10px;
  border-bottom: 2px solid #305792;
  color: #305792;
  font-size: 18px;
  font-weight: bold;
}
ideas-wall-remote-controller .remote-container .content .tab-content {
  display: flex;
  justify-content: space-around;
  height: 100%;
}
ideas-wall-remote-controller .selectors {
  padding-top: 20px;
  padding-bottom: 20px;
  flex: 1;
}
ideas-wall-remote-controller .selectors.selected {
  background: rgba(48, 87, 146, 0.1);
}
ideas-wall-remote-controller .group-buttons {
  margin-top: 50px;
  flex-wrap: wrap;
  width: 90%;
}
ideas-wall-remote-controller .group-buttons span {
  margin-bottom: 15px;
}
ideas-wall-remote-controller button {
  width: 60px;
  height: 60px;
  opacity: 0.6;
}
ideas-wall-remote-controller button.mat-mdc-fab {
  margin: 0;
}
ideas-wall-remote-controller button.mat-mdc-fab mat-icon[svgicon=remote] svg {
  margin-left: 4px;
}
ideas-wall-remote-controller button.selected {
  opacity: 1;
  box-shadow: 0 0 0 3px white, 0 0 0 5px #305792 !important;
}
ideas-wall-remote-controller button + span {
  margin-top: 5px;
  font-weight: bold;
}
ideas-wall-remote-controller .selector-title {
  margin-bottom: 23px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}
ideas-wall-remote-controller .modes-container {
  display: flex;
  flex-direction: row;
  font-size: 13px;
  place-content: center space-evenly;
  align-items: center;
}
ideas-wall-remote-controller .modes-container button {
  background-color: #305792;
}
ideas-wall-remote-controller .modes-container span {
  padding: 0 10px;
}
ideas-wall-remote-controller button.mat-mdc-fab + span mat-icon.mat-icon {
  width: 22px;
  height: 22px;
  font-size: 22px;
  color: black;
}
ideas-wall-remote-controller button.mat-mdc-fab + span mat-icon.mat-icon svg path {
  fill: black;
}
ideas-wall-remote-controller mat-icon.mat-icon {
  width: 33px;
  height: 33px;
  font-size: 33px;
  color: white;
  vertical-align: middle;
}
ideas-wall-remote-controller mat-icon.mat-icon[svgicon=trainer] {
  width: 40px;
  height: 40px;
  font-size: 40px;
}
ideas-wall-remote-controller mat-icon.mat-icon svg path {
  fill: white;
}`, "",{"version":3,"sources":["webpack://./src/app/@modules/ideas-wall/core/remote-controller/remote-controller.component.scss"],"names":[],"mappings":"AACI;EACI,uCAAA;AAAR;AAEQ;EACI,UAAA;EACA,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AAAZ;AAEY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAAhB;AAEgB;EACI,UAAA;EAQA,iBAAA;EACA,kBAAA;AAPpB;AAAoB;EACI,WAAA;EACA,YAAA;EACA,eAAA;AAExB;AAMY;EACI,aAAA;EACA,gCAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAJhB;AAOY;EACI,aAAA;EACA,6BAAA;EACA,YAAA;AALhB;AAUI;EACI,iBAAA;EACA,oBAAA;EACA,OAAA;AARR;AAUQ;EACI,kCAAA;AARZ;AAYI;EACI,gBAAA;EACA,eAAA;EACA,UAAA;AAVR;AAYQ;EACI,mBAAA;AAVZ;AAcI;EACI,WAAA;EACA,YAAA;EACA,YAAA;AAZR;AAcQ;EACI,SAAA;AAZZ;AAcY;EACI,gBAAA;AAZhB;AAgBQ;EACI,UAAA;EACA,yDAAA;AAdZ;AAiBQ;EACI,eAAA;EACA,iBAAA;AAfZ;AAmBI;EACI,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAjBR;AAoBI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,kCAAA;EACA,mBAAA;AAlBR;AAoBQ;EACI,yBAAA;AAlBZ;AAqBQ;EACI,eAAA;AAnBZ;AAuBI;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AArBR;AAsBQ;EACI,WAAA;AApBZ;AAwBI;EAOI,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;AA5BR;AAkBQ;EACI,WAAA;EACA,YAAA;EACA,eAAA;AAhBZ;AAyBQ;EACI,WAAA;AAvBZ","sourcesContent":["ideas-wall-remote-controller {\n    .remote-container {\n        background: #00000059;\n\n        .content {\n            width: 90%;\n            height: 80%;\n            background-color: rgba(255, 255, 255, 0.9);\n            border-radius: 5px;\n            display: flex;\n            flex-direction: column;\n\n            .button-tab {\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                background-color: #305792;\n                margin-right: 10px;\n\n                &.close {\n                    opacity: 1;\n\n                    mat-icon {\n                        width: 20px;\n                        height: 20px;\n                        font-size: 20px;\n                    }\n\n                    margin-top: -25px;\n                    margin-right: -5px;\n                }\n            }\n\n            .tab-header {\n                padding: 10px;\n                border-bottom: 2px solid #305792;\n                color: #305792;\n                font-size: 18px;\n                font-weight: bold;\n            }\n\n            .tab-content {\n                display: flex;\n                justify-content: space-around;\n                height: 100%;\n            }\n        }\n    }\n\n    .selectors {\n        padding-top: 20px;\n        padding-bottom: 20px;\n        flex: 1;\n\n        &.selected {\n            background: rgba(48, 87, 146, 0.1);\n        }\n    }\n\n    .group-buttons {\n        margin-top: 50px;\n        flex-wrap: wrap;\n        width: 90%;\n\n        span {\n            margin-bottom: 15px;\n        }\n    }\n\n    button {\n        width: 60px;\n        height: 60px;\n        opacity: 0.6;\n\n        &.mat-mdc-fab {\n            margin: 0;\n\n            mat-icon[svgicon=\"remote\"] svg {\n                margin-left: 4px;\n            }\n        }\n\n        &.selected {\n            opacity: 1;\n            box-shadow: 0 0 0 3px white, 0 0 0 5px #305792 !important;\n        }\n\n        &+span {\n            margin-top: 5px;\n            font-weight: bold;\n        }\n    }\n\n    .selector-title {\n        margin-bottom: 23px;\n        font-size: 16px;\n        font-weight: bold;\n        text-align: center;\n    }\n\n    .modes-container {\n        display: flex;\n        flex-direction: row;\n        font-size: 13px;\n        place-content: center space-evenly;\n        align-items: center;\n\n        button {\n            background-color: #305792;\n        }\n\n        span {\n            padding: 0 10px;\n        }\n    }\n\n    button.mat-mdc-fab + span mat-icon.mat-icon{\n        width: 22px;\n        height: 22px;\n        font-size: 22px;\n        color: black;\n        svg path {\n            fill: black;\n        }\n    }\n\n    mat-icon.mat-icon {\n        &[svgicon=\"trainer\"] {\n            width: 40px;\n            height: 40px;\n            font-size: 40px;\n        }\n\n        width: 33px;\n        height: 33px;\n        font-size: 33px;\n        color: white;\n        vertical-align: middle;\n\n        svg path {\n            fill: white;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
